import { environment } from '@/environments/environment'

export default [
  { name: 'getAdditionalCharges', url: `${environment.newyorkApiUrl}/v3/coverage/additional-charges`, method: 'get', notCancel: true},
  { name: 'getAdditionalChargesByRateId', url: `${environment.newyorkApiUrl}/v3/coverage/rates/{rate_id}/additional-charges`, method: 'get', notCancel: true},
  { name: 'postAdditionalCharges', url: `${environment.newyorkApiUrl}/v3/coverage/additional-charges`, method: 'post', headers: {'Content-Type': 'multipart/form-data'}},
  { name: 'putAdditionalCharges', url: `${environment.newyorkApiUrl}/v3/coverage/additional-charges`, method: 'put'}
]
